import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input,
  Row,
  Col,
} from "reactstrap";

import api from "../../components/Tienda/api";
import apifunctions from "../../components/Tienda/api/functions";

export const DescripcionPreciosModal = ({ PrecioBase }) => {
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  const [activeCard, setActiveCart] = useState(0);
  const [tarjetas, setTarjetas] = useState([]);

  useEffect(() => {
    const fetchTarjetas = (reintento = 0) => {
      const successCallback = (response) => {
        setTarjetas(response && response.data ? response.data : []);
      };

      const failureCallback = () => {
        if (reintento < 3) fetchTarjetas(reintento + 1);
        else setTarjetas([]);
      };

      apifunctions.get(
        api.api.ventas.tarjetasyplanes,
        "01",
        null,
        {},
        successCallback,
        failureCallback,
        failureCallback
      );
    };

    fetchTarjetas();
  }, []);

  useEffect(() => {
    setActiveCart(0);
  }, [tarjetas.length]);

  // Se multiplica por 1.2 para agregar el recargo del 20% sobre el precio base 
  // y tener el Precio de Lista.
  const valorBaseConRecargo = (PrecioBase || 0) * 1.2;

  const ValorCuota = (interes, nroCuotas) =>
    `$ ${new Intl.NumberFormat("de-DE").format(
      Math.ceil((valorBaseConRecargo * interes) / nroCuotas)
    )}`;

  const Intereses = (interes) =>
    `$ ${new Intl.NumberFormat().format(
      Math.ceil(valorBaseConRecargo * interes - valorBaseConRecargo)
    )}`;

  const TotalFinanciado = (interes) =>
    `$ ${new Intl.NumberFormat().format(
      Math.ceil(valorBaseConRecargo * interes)
    )}`;

  return (
    <div className="">
      <Button className="w-100" color="primary" onClick={toggleModal}>
        <i className="fa fa-credit-card-alt" aria-hidden="true"></i>
        {" Ver cuotas y medios de pago"}
      </Button>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Cuotas y Formas de Pago</ModalHeader>
        <ModalBody className="px-5">
          {tarjetas.length > 0 ? (
            <Fragment>
              <Row>
                <Col xs={9} className="my-auto">
                  <Input
                    value={activeCard}
                    type="select"
                    onChange={(evt) => setActiveCart(Number(evt.target.value))}
                  >
                    {tarjetas.map((card, index) => (
                      <option key={`card-${card.name}-${index}`} value={index}>
                        {card.name}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col xs={3} className="my-1">
                  <img
                    src={tarjetas[activeCard]?.imageSrc}
                    alt={tarjetas[activeCard]?.name}
                    height="40"
                    className="rounded bg-light"
                  />
                </Col>
              </Row>
              <Table>
                <thead>
                  <tr>
                    <th>Cantidad de Cuotas</th>
                    <th>Valor de Cuota</th>
                    {/* <th>Intereses</th> 
                    <th>Total Financiado</th>*/}
                  </tr>
                </thead>
                <tbody>
                  {tarjetas[activeCard]?.name === "Tarjeta Naranja" ? (
                    <Fragment>
                      <td
                        className="text-center text-dark bg-warning"
                        colSpan={3}
                      >
                        <strong>Plan Z con un 12% de interes</strong>
                      </td>
                      {/* 12% con Plan Z */}
                      <td className="text-dark bg-warning">
                        <strong>{TotalFinanciado(1.12)}</strong>
                      </td>
                    </Fragment>
                  ) : (
                    <Fragment></Fragment>
                  )}
                  {tarjetas[activeCard]?.cuotas?.map((cuota, index) => (
                    <tr key={`card-${activeCard}-cuota-${index}`}>
                      <td className="pl-5">{cuota.label}</td>
                      <td className="pl-4">
                        {ValorCuota(cuota.interes, cuota.nroCuotas)}
                      </td>
                      {/* <td>{Intereses(cuota.interes)}</td> 
                      <td>{TotalFinanciado(cuota.interes)}</td>*/}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Fragment>
          ) : (
            <p className="text-center my-3">
              No pudimos cargar las tarjetas en este momento.
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
